import Vue from 'Vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import promise from 'es6-promise'
import '../assets/plugin.js'
import '../assets/css/globel.css'
import '../assets/globle.js'
import filters from "../assets/globle";
import VueI18n from 'vue-i18n'
import { pcaa } from 'area-data-vue';
import 'area-linkage-vue/dist/index.css';
import AreaLinkageVue from 'area-linkage-vue';
import iView from 'iview';
import 'iview/dist/styles/iview.css'; 



// <script src="https://unpkg.com/element-ui/lib/index.js"></script>
Vue.prototype.$pcaa = pcaa;
Vue.use(AreaLinkageVue)

promise.polyfill();
Vue.use(VueI18n)
Vue.use(iView);
// const i18n = new VueI18n({
//   locale: window.localStorage.getItem('user_lang') == null ? "cn" : window.localStorage.getItem('user_lang'),    // 语言标识
//   messages: {
//     'cn': require('./utils/lang/cn'),   // 中文语言包
//     'en': require('./utils/lang/en')    // 英文语言包
//   },
// })

import axios from 'axios'

axios.defaults.withCredentials = true
// axios.defaults.headers.common['Cookie'] = 'ULT=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJkYXRhIjoiMSIsImlzcyI6InNoYXBpLmNsb3RoZXNtYWtlLmNvbS5jbiIsImF1ZCI6InNoYXBpLmNsb3RoZXNtYWtlLmNvbS5jbiIsImlhdCI6MTU4NzM4NzUyMywiZXhwIjoxNjQ3ODY3NTIzfQ.kvDc6vPT0di5QEUmpqFePvCwz1Ev8I3LTsFkBwJA1W4Rln2zvVx2tnRefenP0Jdjp_GB_WmaxGboMapCurbyusddaxmYWsrD-OOAJ5A-ctfu-3bcmTlfi9GrTTnQF6IvY_KOToKI05uD2MNRdZGqPoh6hnljFmncG8xK_zkwB4o;';

// 拦截axios请求 设置返回数据
axios.interceptors.response.use(
  function(res) {
    //store.commit(types.SET_AJAX_LOADING, false)
    switch (res.data.code) {
      case 1001:
        Vue.prototype.$message.error(res.data.msg);
        window.location.href = "/page/login"
        return Promise.reject(res)
      case 200:
        return res.data
      default:
          if (res.data.code > 0) {
            Vue.prototype.$message.error(res.data.msg);
            return Promise.reject(res)
          }

          return res
    }
  },
  function(err) {
    if (err && err.response) {
        switch (err.response.status) {
            case 400: err.message = '请求错误(400)' ; break;
            case 401: err.message = '未授权，请重新登录(401)'; break;
            case 403: err.message = '您没有权限访问此页面'; break;
            case 404: err.message = '请求出错(404)'; break;
            case 408: err.message = '请求超时(408)'; break;
            case 500: err.message = '服务器错误(500)'; break;
            case 501: err.message = '服务未实现(501)'; break;
            case 502: err.message = '网络错误(502)'; break;
            case 503: err.message = '服务不可用(503)'; break;
            case 504: err.message = '网络超时(504)'; break;
            case 505: err.message = 'HTTP版本不受支持(505)'; break;
            default: err.message = '连接出错!';
        }
    }else{
        err.message = '连接服务器失败!'
    }

    Vue.prototype.$message.error(err.message);

    return Promise.reject(err)
  }
)

axios.defaults.baseURL = process.env.api
if (location.hostname === 'localhost') {
  Vue.prototype.HTTPLOCAT = ''
} else {
  // const http = window.location.protocol + '//' + location.hostname + ':' + location.port
  // Vue.prototype.HTTPLOCAT = http + '/netopenws/wt/vue/dist' // （这个路径改为你服务器的路径）
}
// Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
//   return moment(dataStr).format(pattern)

// })
// Vue.prototype.$moment = moment
Vue.prototype.$http = axios

import locale from 'element-ui/lib/locale/lang/en'

if(window.localStorage.getItem('locale')==null){
    var lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
    lang = lang.substr(0, 2);
    lang = lang == 'zh' || lang == 'en' ? lang : 'zh';
    if(lang=='zh'){
        Vue.use(ElementUI);
    }else{
        Vue.use(ElementUI,{ locale });
    }
}else if(window.localStorage.getItem('locale')=='zh'){
    Vue.use(ElementUI);
}else if(window.localStorage.getItem('locale')=='en'){
    Vue.use(ElementUI,{ locale });
}

Object.keys(filters).forEach(function(key) {
  Vue.filter(key, (filters)[key]);
});

// Vue.filter('uploadUrl', function uploadUrl(url) {
//   if (url == "") return "";
  
//   if (process.env.NODE_ENV === "production") {
//     return 'https://shapi.clothesmake.com.cn/'+url;
//   } else {
//     return 'https://shapi.clothesmake.com.cn/'+url;
//     return 'http://sh.com/'+url;
//   }
// });

export default Vue



// WEBPACK FOOTER //
// ./src/pages/index.js